export const attendanceCard = 'mt-4 w-11/12 mx-auto bg-uiBg';
